import { render, staticRenderFns } from "./TitleChunk.vue?vue&type=template&id=244ebff8&scoped=true&"
import script from "./TitleChunk.vue?vue&type=script&lang=ts&"
export * from "./TitleChunk.vue?vue&type=script&lang=ts&"
import style0 from "./TitleChunk.vue?vue&type=style&index=0&id=244ebff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ebff8",
  null
  
)

export default component.exports